import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import Loading from './components/Loading/Loading';
import Home from './pages/Home';
import Registration from './pages/Registration';
import Topics from './pages/Topics';
import KeyDates from './pages/KeyDates';
import Submissions from './pages/Submissions';
import Speakers from './pages/Speakers';
import Committee from './pages/Committee/Committee';
import Contact from './pages/Contact';
import GlobalStyles from './styles/GlobalStyles';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  if (isLoading) {
    return (
      <>
        <GlobalStyles />
        <Loading onLoadingComplete={() => setIsLoading(false)} />
      </>
    );
  }

  return (
    <Router>
      <GlobalStyles />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/registration" element={<Registration />} />
          <Route path="/topics" element={<Topics />} />
          <Route path="/key-dates" element={<KeyDates />} />
          <Route path="/submissions" element={<Submissions />} />
          <Route path="/speakers" element={<Speakers />} />
          <Route path="/committee" element={<Committee />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
}

export default App;
